import type { AuthModel } from '@develop/ia-api-library'

export enum SessionDuration {
  REMEMBER_ME = 30,
  DEFAULT = 2,
}

export type AuthCookieModel = AuthModel & { rememberMe?: boolean }
